import * as React from "react"
import { formatDate } from "@ui-seeker/utils"
import { Box } from "@mui/material"

import { STOCK_STATUS } from "../../@constants"
import { NotAllowedBlock } from "@components"


export default function lastOutStockColumn() {
	return {
		name: 'lastOutOfStock',
		label: 'Last day out of stock',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'wrap', maxWidth: 50 }
			}),
			customBodyRowRender: (value, row) => <Box sx={{
				color: row.stock === STOCK_STATUS.STOCK ? "text.primary" : 'text.disabled',
				textAlign: 'center'
			}}>
				{ value ? formatDate(value, { isString: true }) : <NotAllowedBlock /> }
			</Box>
		}
	}
}